import React from 'react';
import { StrategySelector } from '../../common/StrategySelector';
import { Strategy } from 'src/services/strategies.service';
import '../../../../styles/components/forms/strategy-selector.css';

interface StrategiesSectionProps {
  strategies: Strategy[];
  isLoading: boolean;
  error: string | null;
  onGenerateStrategies: () => Promise<void>;
  onStrategyToggle: (strategy: string) => void;
  selectedStrategies: string[];
  smartGoal: string | null;
  className?: string;
}

export const StrategiesSection: React.FC<StrategiesSectionProps> = ({
  strategies,
  isLoading,
  error,
  onGenerateStrategies,
  onStrategyToggle,
  selectedStrategies,
  smartGoal,
  className,
}) => {
  return (
    <StrategySelector
      strategies={strategies}
      isLoading={isLoading}
      error={error}
      onGenerateStrategies={onGenerateStrategies}
      onStrategyToggle={onStrategyToggle}
      selectedStrategies={selectedStrategies}
      smartGoal={smartGoal}
      className={className}
    />
  );
};
